import React, { useEffect, useState } from 'react';
import * as JsSearch from 'js-search';
import styled, { css } from 'styled-components';
import { brandColours, maxBreakpointQuery, visuallyHidden } from '../styles';
import searchIcon from '../images/search-icon.svg';
import altSearchIcon from '../images/alt-search-icon.svg';

const StyledSearch = styled.form``;

const StyledInputWrapper = styled.label`
  position: relative;

  ${maxBreakpointQuery.smedium`
    width: 100%;
  `}

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-repeat: no-repeat;
    display: inline-block;
  }

  ${({ $alt }) => {
    if (!$alt) {
      return css`
        &:before {
          left: 20px;
          background-image: url(${searchIcon});
          width: 22px;
          height: 22px;
        }
      `;
    } else {
      return css`
        &:before {
          right: 20px;
          background-image: url(${altSearchIcon});
          width: 18px;
          height: 18px;
        }
      `;
    }
  }}
`;

const StyledLabel = styled.span`
  ${visuallyHidden()};
`;

const StyledInput = styled.input`
  padding: 18px;
  border: solid 1px;
  width: 100%;

  ${({ $alt }) => {
    if (!$alt) {
      return css`
        border-radius: 30px;
        border-color: ${brandColours.secondary};
        padding-left: 58px;
      `;
    } else {
      return css`
        border-color: ${brandColours.undecenary};
        padding-right: 58px;
      `;
    }
  }}
`;

const Search = ({ items, setResults, location, alt, ...props }) => {
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const searchData = async () => {
      const search = new JsSearch.Search('id');
      search.addIndex('heading');
      search.addIndex('summary');
      search.addDocuments(items);

      if (searchTerm.length > 2) {
        const results = await search
          .search(searchTerm)
          .sort((a, b) => b.heading - a.heading);
        setResults(results && results.length > 0 ? results : null);
      } else {
        setResults(undefined);
      }
    };

    searchData();
  }, [items, setResults, searchTerm]);

  const searchItems = term => {
    setSearchTerm(term);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setSearchTerm(searchParams.get('term') || '');
  }, [location.search]);

  return (
    <StyledSearch {...props}>
      <StyledInputWrapper $alt={alt}>
        <StyledLabel>Search Blog Posts</StyledLabel>
        <StyledInput
          type="search"
          name="term"
          value={searchTerm ? searchTerm : ''}
          placeholder="Search Posts"
          onChange={e => searchItems(e.target.value)}
          $alt={alt}
        />
      </StyledInputWrapper>
    </StyledSearch>
  );
};

export default Search;
